import { createConsumer } from '@rails/actioncable';

const consumer = createConsumer('/cable');

consumer.subscriptions.create({
  channel: 'EventChannel',
}, {
  received(data) {
    this.handleReceived(data);
  },
  handleReceived(data) {
    window.dataLayer.push({
      event: 'userAction',
      ...data,
    });
  },
});
